module.exports = __webpack_public_path__ + "assets/img/ZT2220-M.9b80f4c3.png";